import { defineMessages } from "react-intl";

import {
	resultMessages,
	validator
} from "lib/build/forms/ltx/phase-i/imaging-procedures/abdominalUltrasound";

import { FieldData, FieldsetData } from "src/features/forms";
import { genericErrorMessages } from "src/messages/generic";
import { LeafNode } from "src/modules/shared/form-explorer";

const messages = defineMessages({
	abdominalUltrasound: {
		id: "form.abdominal_ultrasound",
		defaultMessage: "Hasi ultrahang"
	},
	result: {
		id: "form.abdominal_ultrasound.result",
		defaultMessage: "Eltérés"
	},
	comment: {
		id: "form.abdominal_ultrasound.comment",
		defaultMessage: "Megjegyzés"
	}
});

const fields: { [key: string]: FieldData } = {
	result: {
		type: "field",
		path: ["result"],
		label: messages.result,
		errorMessages: genericErrorMessages,
		input: { type: "button-group", props: { labels: resultMessages } }
	},
	comment: {
		type: "field",
		path: ["resultComment"],
		label: messages.comment,
		errorMessages: genericErrorMessages,
		input: { type: "textarea", props: {} }
	}
};

const fieldset: FieldsetData = {
	rows: [
		{ columns: [{ width: 12, field: fields.result }] },
		{ columns: [{ width: 12, field: fields.comment }] }
	]
};

export const node: LeafNode = {
	id: "abdominalUltrasound",
	value: {
		title: messages.abdominalUltrasound,
		validator,
		fieldset,
		isImportant: true
	}
};
